import { watchCleanCartOverview } from './CleanCartOverview';
import { watchGetCartOverviewManager } from './GetCartOverviewManager.saga';
import { watchCartOverviewUpdate } from './ListenToCartUpdate.saga';

export const SAGAS = [
  watchGetCartOverviewManager,
  watchCartOverviewUpdate,
  watchCleanCartOverview,
];
